module.exports = __webpack_public_path__ + "static/ap-004f9219651f13e32af42ca7dd6ddd61.jpg";